import React from 'react'
import PropTypes from 'prop-types'

const BarChartSmIcon = ({}) => {
  return (
    <svg
      className="bar-chart-sm-icon"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="4.36328"
        width="2.90909"
        height="10.9091"
        fill="#0F7ABD"
      />
      <rect
        x="6.54541"
        width="2.90909"
        height="15.2727"
        fill="#0F7ABD"
      />
      <rect
        x="13.0908"
        y="8.72754"
        width="2.90909"
        height="6.54545"
        fill="#0F7ABD"
      />
    </svg>
  )
}

export default BarChartSmIcon
